













































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import echarts from 'echarts';
import { AcgnFormTitle, AcgnFormContent } from '@/components';
import { Tooltip, DatePicker, RadioGroup, RadioButton, Cascader } from 'element-ui';
import {
  AcgnStatisticStaffCard,
  AcgnStatisticChart,
  AcgnStatisticStaffCardm,
  AcgnStatisticStaffChartd,
  AcgnStaffCake
} from './components';
import { Tabs, TabPane } from 'element-ui';

const StaffAction = namespace('desk/staff').Action;
const AuthGetter = namespace('desk/auth').Getter;
const StaffGetter = namespace('desk/staff').Getter;

// 员工统计
@Component({
  components: {
    AcgnFormTitle,
    AcgnFormContent,
    AcgnStatisticStaffCard,
    AcgnStatisticChart,
    AcgnStatisticStaffCardm,
    AcgnStatisticStaffChartd,
    AcgnStaffCake,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Cascader.name]: Cascader
  }
})
export default class AcgnStatisticStaff extends Vue {
  public name: string = 'AcgnStatisticStaff';

  @Prop({ default: true }) public isShowManage: boolean; // 是否显示管理方（显示管理方才显示成员筛选）
  @Prop({ default: null }) public comicId: number | null; // 项目id (有项目id才有目标进度)
  @Prop({ default: '成员统计' }) public title: string; // 头部显示标题
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  // 1：管理方-员工 2：管理方-项目 3：创作方总览 4：创作方-项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  // 1：员工 2：项目
  @Prop({ default: 1 }) public routeTypeStaff: number; // 用于管理方统计中创作方管理的跳转

  // 如管理方内嵌的创作方需要此标识，用户筛选条件展示
  @Prop({ default: false }) public isExternal: boolean; // 是否扩展显示

  @Prop({ default: true }) public isShowTitle: boolean; // 是否显示标题

  @Prop({ default: false }) public isSimpleManager: boolean; // 是否去除管理数据

  private chartData: any = {
    staffId: null,
    statusId: 1,
    timeId: 1,
    scopeId: 1,
    start_time: '',
    start_end: '',
    tabPosition: 'top'
  };

  private activeName: string = 'first';
}
